// extracted by mini-css-extract-plugin
export default {"counter":"counter__counter__hc4Cp","minus":"counter__minus__xrDwu","num":"counter__num__kUS56","plus":"counter__plus__GKxsw","inactive":"counter__inactive__juliW"};